module.exports = __webpack_public_path__ + "static/media/FiltradoRojo.cec23d8d.pdf";